<div class="dvb-kibon-ref-nummer" ng-class="{ 'ignored': vm.referenzNummerIgnoriert }">
    <span ng-bind="vm.kibonRefNrInfo.getRefNr()"
          uib-tooltip="{{vm.text}}"
          tooltip-append-to-body="true"
          tooltip-placement="top-left">
    </span>
</div>
